import {createClient} from "@supabase/supabase-js";
import {getUserID} from "./userhandler.js";

// Import models
import Participant from "../models/Participant.js";

// --- Supabase setup ---
export const supabase = createClient(
    "https://gjgdvlogdjmnqtggdyef.supabase.co/",
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImdqZ2R2bG9nZGptbnF0Z2dkeWVmIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDIyOTg0MjksImV4cCI6MjA1Nzg3NDQyOX0.kMMaGu8P-imeo0q2TUmXcL_gyn42XUKvRNd5BdDsVXY"
);

// --- Events ---
export const fetchEventByIdFromDatabase = async (id) => {
    try {
        const { data, error } = await supabase.from("Events").select().eq("id", id).single();
        if (error) throw error;
        return data;
    } catch (error) {
        console.error(error);
        return null;
    }
};

export const fetchWSVusageFromDatabase = async (eventId) => {
    try {
        const { data, error } = await supabase
            .from("Events")
            .select("using_wsv")
            .eq("id", eventId)
            .single();
        if (error) throw error;
        return data;
    } catch (error) {
        console.error(error);
        return null;
    }
};

// --- Clubs ---
export const fetchClubIDFromDatabase = async () => {
    try {
        const { data, error } = await supabase
            .from("Clubs")
            .select("id")
            .eq("user_id", await getUserID())
            .single();
        if (error) throw error;
        return data;
    } catch (error) {
        console.error(error);
        return null;
    }
};

export const fetchClubDataFromDatabase = async (clubId) => {
    try {
        const { data, error } = await supabase
            .from("Clubs")
            .select("club, shortClub, contact, phone, address, mail")
            .eq("id", clubId);

        if (error) throw error;
        return data;
    } catch (error) {
        console.error(error);
        return null;
    }
}

export const updateClubDataInDatabase = async (clubId, clubData) => {
    try {
        const { error } = await supabase
            .from("Clubs")
            .update(clubData)
            .eq("id", clubId);
        if (error) throw error;
        return true;
    } catch (error) {
        console.error(error);
        return null;
    }
}

// --- Participants ---
export const fetchParticipantsByClubIDFromDatabase = async (clubId) => {
    try {
        const { data, error } = await supabase.from("Participants").select().eq("club_id", clubId);
        if (error) throw error;
        return data.map((p) => new Participant(p.id, p.first_name, p.last_name, p.birthyear, p.info));
    } catch (error) {
        console.error(error);
        return [];
    }
};

export const insertParticipantFromDatabase = async (club_id, first_name, last_name, birthyear, wsvInfo, verified_status) => {
    try {
        const { error } = await supabase.from("Participants").insert({
            club_id,
            first_name,
            last_name,
            birthyear,
            info: wsvInfo,
            verified_status,
        });
        if (error) throw error;
        return true;
    } catch (error) {
        console.error(error);
        return null;
    }
};

export const updateParticipantFromDatabase = async (id, first_name, last_name, birthYear, wsvInfo, verified_status) => {
    try {
        const { error } = await supabase
            .from("Participants")
            .update({
                first_name,
                last_name,
                birthyear: birthYear,
                info: wsvInfo,
                verified_status,
            })
            .eq("id", id);
        if (error) throw error;
        return true;
    } catch (error) {
        console.error(error);
        return null;
    }
};

export const deleteParticipantByIdFromDatabase = async (id) => {
    try {
        const { error } = await supabase.from("Participants").delete().eq("id", id);
        if (error) throw error;
        return true;
    } catch (error) {
        console.error(error);
        return null;
    }
};

// --- Distances ---
export const fetchDistanceDataFromDatabase = async (eventId) => {
    try {
        const { data, error } = await supabase
            .from("Distances")
            .select(`
                id,
                distance,
                Boat (
                    id,
                    boat,
                    amount_of_people
                ),
                Gender (
                    id,
                    gender
                ),
                Categories (
                    id,
                    category
                )
            `)
            .eq("event_id", eventId);

        if (error) throw error;
        if (!data) return [];

        return data;
    } catch (error) {
        console.error(error);
        return null;
    }
};

// --- Registrations ---

export const fetchParticipantsByDistanceId = async (distanceId) => {
    try {
        const { data, error } = await supabase
            .from("Registrations")
            .select(`
                id,
                participant_id:Participants!Registrations_participant_id_fkey (
                    id,
                    club_id,
                    first_name,
                    last_name
                ),
                participant_id2:Participants!Registrations_participant_id2_fkey (
                    id,
                    club_id,
                    first_name,
                    last_name
                ),
                participant_id3:Participants!Registrations_participant_id3_fkey (
                    id,
                    club_id,
                    first_name,
                    last_name
                ),
                participant_id4:Participants!Registrations_participant_id4_fkey (
                    id,
                    club_id,
                    first_name,
                    last_name
                )
            `)
            .eq("distance_id", distanceId);

        if (error) throw error;
        if (!data) return null;

        return data;
    } catch (error) {
        console.error(error);
        return null;
    }
};

export const getAmountOfParticipantsInBoat = async (rowId, distanceId) => {
    try {
        const { data, error } = await supabase
            .from("Registrations")
            .select(`
                participant_id,
                participant_id2,
                participant_id3,
                participant_id4
            `)
            .eq("id", rowId)
            .eq("distance_id", distanceId)
            .single();
        if (error) throw error;

        return [
            data.participant_id,
            data.participant_id2,
            data.participant_id3,
            data.participant_id4,
        ].filter(v => v != null).length;
    } catch (error) {
        console.error(error);
        return null;
    }
}

export const addParticipantToDatabaseByRowID = async (rowId, participantId, distanceId) => {
    try {
        const { data, error: error1 } = await supabase
            .from("Registrations")
            .select(`
                participant_id,
                participant_id2,
                participant_id3,
                participant_id4
            `)
            .eq("id", rowId)
            .eq("distance_id", distanceId)
            .single();

        if (error1) throw error1;

        const participantKey = Object.entries(data)
            .find(([key, value]) => /^participant_id\d*$/.test(key) && value === null)?.[0];

        if (!participantKey) {
            console.error("No available participant slot found.");
            return null;
        }

        const { error: error2 } = await supabase.from("Registrations")
            .update({
                [participantKey]: participantId
            })
            .eq("id", rowId)
            .eq("distance_id", distanceId);

        if (error2) throw error2;

        return true;
    } catch (error) {
        console.error(error);
        return null;
    }
}

export const addParticipantToDatabase = async (eventId, distanceId, participantId) => {
    try {
        const { error } = await supabase.from("Registrations")
            .insert({
                participant_id: participantId,
                distance_id: distanceId,
                event_id: eventId
            });

        return true;
    } catch (error) {
        console.error(error);
        return null;
    }
}

export const deleteRegistrationFromDatabase = async (id) => {
    try {
        const { error} = await supabase.from("Registrations")
            .delete()
            .eq("id", id);

        return true;
    } catch (error) {
        console.error(error);
        return null;
    }
}

export const deleteParticipantFromRegistrationFromDatabase = async (id, participantId, participantKey, distanceId) => {
    try {
        const amountOfParticipants = await getAmountOfParticipantsInBoat(id, distanceId);

        if (amountOfParticipants <= 1) {
            return await deleteRegistrationFromDatabase(id);
        }

        const {error} = await supabase.from("Registrations")
            .update({
                [participantKey]: null
            })
            .eq("id", id)
            .eq(participantKey, participantId);

        if (error) throw error;

        return true;
    } catch (error) {
        console.error(error);
        return null;
    }
}

export const fetchEventsFromDatabase = async () => {
    try {
        const today = new Date().toISOString().split('T')[0];
        const { data, error } = await supabase.from("Events")
            .select()
            .eq("is_public", true)
            .gte("endDate", today)
            .order("startDate", { ascending: true });
        if (error) throw error;
        return data;
    } catch (error) {
        console.error(error);
        return null;
    }
}

/*
 - SCHEDULE
*/
export const fetchScheduleFromDatabase = async (eventId) => {
     const { data, error } = await supabase.from("Schedules")
        .select("*")
        .eq("event_id", eventId)
        .order("race_nr");

     if (error) {
         console.error(error);
         return null;
     }

     return data;
}